export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResetPassword.vue?vue&type=style&index=1&id=184a8a30&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/components/recover/ResetPassword.vue?vue&type=style&index=1&id=184a8a30&prod&scoped=true&lang=css&
// module id = 1521
// module chunks = 0